import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);